(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/day-time-limit/assets/javascripts/notices.js') >= 0) return;  svs.modules.push('/components/accountservices/day-time-limit/assets/javascripts/notices.js');
"use strict";

svs.accountservices = svs.accountservices || {};
svs.accountservices.day_time_limit = svs.accountservices.day_time_limit || {};
svs.accountservices.day_time_limit.notices = svs.accountservices.day_time_limit.notices || {};
const logger = svs.core.log.getLogger('accountservices:components:day-time-limit');
(function (svs) {
  function pay() {
    logger.info('Shows message for user who has reached its day time limit while trying to pay.');
    const dialogObject = {
      title: 'Betalning misslyckades',
      message: 'Du har uppnått din dagliga tidsgräns. När du har nått din tidsgräns kan du inte betala spel eller sätta in pengar.',
      buttons: [{
        text: 'Okej'
      }]
    };
    svs.accountservices.day_time_limit.showErrorDialog(dialogObject);
  }
  function deposit() {
    logger.info('Shows message for user who has reached its day time limit while trying to deposit money.');
    const dialogObject = {
      title: 'Insättning misslyckades',
      message: 'Du har uppnått din dagliga tidsgräns. När du har nått din tidsgräns kan du inte betala spel eller sätta in pengar.',
      buttons: [{
        text: 'Okej'
      }]
    };
    svs.accountservices.day_time_limit.showErrorDialog(dialogObject);
  }
  function demoTicket() {
    logger.info('Shows message for user who has reached its day time limit while trying to scratch a demo ticket.');
    const dialogObject = {
      title: 'Provspel misslyckades',
      message: 'Du har uppnått din dagliga tidsgräns',
      buttons: [{
        text: 'Okej'
      }]
    };
    svs.accountservices.day_time_limit.showErrorDialog(dialogObject);
  }
  function createSyndicate(callback) {
    logger.info('Shows message for user who has reached its day time limit while trying to create syndicate.');
    const dialogObject = {
      title: 'Skapa lag misslyckades',
      message: 'Du har uppnått din dagliga tidsgräns. När du har nått din tidsgräns kan du inte skapa eller gå med i lag.',
      buttons: [{
        text: 'Okej',
        callback
      }]
    };
    svs.accountservices.day_time_limit.showErrorDialog(dialogObject);
  }
  function depositSyndicate() {
    const dialogObject = {
      title: 'Överföring misslyckades',
      message: 'Du har uppnått din dagliga tidsgräns. När du har nått din tidsgräns kan du inte betala spel eller sätta in pengar.',
      buttons: [{
        text: 'Okej'
      }]
    };
    svs.accountservices.day_time_limit.showErrorDialog(dialogObject);
  }
  function acceptInviteSyndicate(callback) {
    logger.info('Shows message for user who has reached its day time limit while trying to accept invite to syndicate.');
    const dialogObject = {
      title: 'Gå med i lag misslyckades',
      message: 'Du har uppnått din dagliga tidsgräns. När du har nått din tidsgräns kan du inte skapa eller gå med i lag.',
      buttons: [{
        text: 'Okej',
        callback
      }]
    };
    svs.accountservices.day_time_limit.showErrorDialog(dialogObject);
  }
  function syndicatePlay(callback) {
    logger.info('Shows message for user who has reached its day time limit while trying to play syndicate games.');
    const dialogObject = {
      title: 'Lägga spel misslyckades',
      message: 'Du har uppnått din dagliga tidsgräns. När du har nått din tidsgräns kan du inte lägga spel med ditt lag.',
      buttons: [{
        text: 'Okej',
        callback
      }]
    };
    svs.accountservices.day_time_limit.showErrorDialog(dialogObject);
  }
  function syndicate(callback) {
    logger.info('Shows message for user who has reached its day time limit while trying to do some activities for syndicate.');
    const dialogObject = {
      title: 'Vald funktion misslyckades',
      message: 'Du har uppnått din dagliga tidsgräns. När du har nått din tidsgräns kan du inte utföra vald funktion.',
      buttons: [{
        text: 'Okej',
        callback
      }]
    };
    svs.accountservices.day_time_limit.showErrorDialog(dialogObject);
  }
  function voucher() {
    logger.info('Shows message for user who has reached its day time limit while trying to use a voucher.');
    const dialogObject = {
      title: 'Inlösen av presentkod misslyckades',
      message: 'Du har uppnått din dagliga tidsgräns och kan inte lösa presentkod. <br><br> Spel på Svenska Spels skraplotter i butik omfattas inte av tidsgräns.',
      buttons: [{
        text: 'Okej'
      }]
    };
    svs.accountservices.day_time_limit.showErrorDialog(dialogObject);
  }
  svs.accountservices.day_time_limit.notices.pay = pay;
  svs.accountservices.day_time_limit.notices.deposit = deposit;
  svs.accountservices.day_time_limit.notices.demoTicket = demoTicket;
  svs.accountservices.day_time_limit.notices.createSyndicate = createSyndicate;
  svs.accountservices.day_time_limit.notices.depositSyndicate = depositSyndicate;
  svs.accountservices.day_time_limit.notices.acceptInviteSyndicate = acceptInviteSyndicate;
  svs.accountservices.day_time_limit.notices.syndicatePlay = syndicatePlay;
  svs.accountservices.day_time_limit.notices.syndicate = syndicate;
  svs.accountservices.day_time_limit.notices.voucher = voucher;
})(svs);

 })(window);